<template>
  <span>
    <v-btn v-bind="{ color, dark, icon: icon && !fab, fab, small, loading }" @click="deleteItem">
      <slot><v-icon color="red">delete</v-icon></slot>
    </v-btn>

    <v-dialog dark v-model="constraintModal" max-width="300">
      <v-alert type="warning" dark>{{ constraintError }}</v-alert>
    </v-dialog>

    <v-dialog :value="displayLoadingDialog && loading" persistent width="300">
      <v-card color="info" dark>
        <v-card-text>
          {{ trans('common.loading') }}
          <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </span>
</template>

<script>
export default {
  name: "DeleteItemBtn",
  props: {
    icon: { type: Boolean, default: true },
    color: {},
    dark: {},
    fab: {},
    small: {},

    action: { type: String, required: true },
    confirmMessage: { type: String, default() { return trans('common.confirm-delete') } },
    autoRedirect: { type: Boolean, default: true },
    displayConstraintError: { type: Boolean, default: true },
    displayLoadingDialog: { type: Boolean, default: true },
  },
  data() {
    return {
      loading: false,
      constraintModal: false,
      constraintError: null,
    };
  },
  methods: {

    deleteItem() {
      if (confirm(this.confirmMessage)) {
        this.loading = true;
        axios.delete(this.action)
          .then(r => {
            this.$emit('success', r.data);
            if (this.autoRedirect && r.data.redirect) {
              location.href = r.data.redirect;
            }
          })
          .catch(e => {
            console.error({ e })
            this.$emit('error', e);
            if (e.response && e.response.status === 409) {
              if (this.displayConstraintError) {
                this.constraintModal = true;
                this.constraintError = (e.response.data && e.response.data.message) || (e.response.statusText);
              }
            }
          })
          .finally(() => { this.loading = false; });
      }
    }
  }
}
</script>
